import {Rng} from '../../shared';
import type {Place} from '../sim/expedition';
export const WORLD_FAMILIES=['cloister','forest-clearing','reed-causeway','caravanserai','mountain-pass','harbour','orchard-village','broken-forum','crystal-quarry','winter-fjord','cinder-caldera','ossuary'] as const;
export type WorldFamily=typeof WORLD_FAMILIES[number];
export interface WorldComposition {family:WorldFamily;variant:0|1|2;seed:number;focalX:number;secondaryX:number;entryX:number;horizon:number;structureCount:number;spread:number;relief:number;lean:number;cloudCount:number}
/** Art-only stream: resizing and thumbnail detail never change the geography. */
export function worldComposition(p:Place):WorldComposition {
 const r=new Rng(`painted-world:${p.seed}:${p.biome}`),variant=r.int(0,2) as 0|1|2;
 return {family:WORLD_FAMILIES[Math.abs(Math.trunc(p.biome))%12],variant,seed:p.seed,
  focalX:[.31,.57,.72][variant]+(r.float()-.5)*.07,secondaryX:[.76,.22,.36][variant]+(r.float()-.5)*.05,
  entryX:[.18,.76,.48][variant]+(r.float()-.5)*.13,horizon:r.int(240,336),structureCount:r.int(3,6),
  spread:r.float(),relief:r.float(),lean:r.float()-.5,cloudCount:r.int(1,5)};
}
